import evpng from "../assets/evpng.png";
export default function About() {
  return (
   <section id="about" className="py-16 bg-gradient-to-b from-white to-green-50">
  <div className="container mx-auto px-6">
    
   <h3
  className="text-4xl font-extrabold text-center mb-10 bg-gradient-to-r from-green-600 to-green-800 bg-clip-text text-transparent drop-shadow-md"
  style={{
    fontSize: window.innerWidth < 768 ? "26px" : "40px",
    marginBottom: window.innerWidth < 768 ? "20px" : "40px",
    lineHeight: window.innerWidth < 768 ? "1.2" : "1.3",
  }}
>
  About SSP NextGen E-Bikes
</h3>

    <div className="grid md:grid-cols-2 gap-10 items-center">

      {/* LEFT SIDE IMAGE */}
      <div 
        className="flex justify-center"
        data-aos="fade-right"
      >
        <img
          src={evpng}
          alt="E-bike illustration"
          className="w-72 md:w-96 drop-shadow-2xl animate-pulse-slow"
        />
      </div>

      {/* RIGHT SIDE TEXT */}
<div 
  className="bg-white shadow-xl rounded-xl p-8 border-l-4 border-green-600"
  data-aos="fade-left"
  style={{
    padding: window.innerWidth < 768 ? "20px" : "32px",
  }}
>
  <p
    className="text-xl text-gray-700 mb-4 italic"
    style={{
      fontSize: window.innerWidth < 768 ? "16px" : "20px",
      lineHeight: window.innerWidth < 768 ? "1.4" : "1.6",
    }}
  >
    "Ride the change. Choose clean. Choose green."
  </p>

  <p
    className="text-gray-700 leading-relaxed mb-4"
    style={{
      fontSize: window.innerWidth < 768 ? "14px" : "16px",
      lineHeight: window.innerWidth < 768 ? "1.5" : "1.7",
    }}
  >
    At <strong className="text-green-700">SSP NextGen E-Bikes</strong>, we believe the future of transportation is 
    electric. We are driven by innovation, sustainability, and the mission to build a 
    cleaner and smarter tomorrow.
  </p>

  <p
    className="text-gray-700 leading-relaxed mb-4"
    style={{
      fontSize: window.innerWidth < 768 ? "14px" : "16px",
    }}
  >
    Based in the heart of Hyderabad, we specialize in high-performance electric bikes 
    crafted for modern commuters. We proudly offer the 
    <strong className="text-green-700"> Best E-Bikes in Kukatpally</strong>, trusted for their efficiency, durability, 
    and advanced riding comfort.
  </p>

  <p
    className="text-gray-700 leading-relaxed mb-4"
    style={{
      fontSize: window.innerWidth < 768 ? "14px" : "16px",
    }}
  >
    Our customers also choose us for the 
    <strong className="text-green-700"> Best Electric Bikes in Kukatpally</strong>, known for smooth performance, 
    long range and low maintenance.
  </p>

  <p
    className="text-gray-700 leading-relaxed mb-4"
    style={{
      fontSize: window.innerWidth < 768 ? "14px" : "16px",
    }}
  >
    We additionally provide the 
    <strong className="text-green-700"> Best E-went Bikes in Kukatpally</strong>, offering affordable, reliable and 
    eco-friendly mobility solutions for daily commuting.
  </p>

  <p
    className="text-gray-700 leading-relaxed mb-4"
    style={{
      fontSize: window.innerWidth < 768 ? "14px" : "16px",
    }}
  >
    With trusted engineering, customer-first service, and cutting-edge EV technology, 
    SSP NextGen is not just a brand—it's a movement. Join thousands of riders choosing 
    a greener lifestyle.
  </p>

  <p
    className="text-green-700 font-semibold mt-4"
    style={{
      fontSize: window.innerWidth < 768 ? "16px" : "18px",
    }}
  >
    “Your electric journey starts here.”
  </p>
</div>

    </div>

    {/* ICON HIGHLIGHTS */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center mt-14">

      <div className="p-6 bg-white shadow-md rounded-lg hover:shadow-xl transition">
        <span className="text-4xl">⚡</span>
        <p className="mt-2 font-semibold text-gray-700">High Performance</p>
      </div>

      <div className="p-6 bg-white shadow-md rounded-lg hover:shadow-xl transition">
        <span className="text-4xl">🌱</span>
        <p className="mt-2 font-semibold text-gray-700">Eco Friendly</p>
      </div>

      <div className="p-6 bg-white shadow-md rounded-lg hover:shadow-xl transition">
        <span className="text-4xl">🔒</span>
        <p className="mt-2 font-semibold text-gray-700">Advanced Safety</p>
      </div>

      <div className="p-6 bg-white shadow-md rounded-lg hover:shadow-xl transition">
        <span className="text-4xl">🛠</span>
        <p className="mt-2 font-semibold text-gray-700">Low Maintenance</p>
      </div>

    </div>

  </div>
</section>

  );
}
